/**
 * Map FIFA 3-letter team codes (football-data.org `team.tla`) to flag-icons ISO slugs.
 * @see https://flagicons.lipis.dev/
 */
const FIFA_TLA_TO_FLAG = {
  ALG: 'dz',
  ARG: 'ar',
  AUS: 'au',
  AUT: 'at',
  BEL: 'be',
  BIH: 'ba',
  BRA: 'br',
  CAN: 'ca',
  CHI: 'cl',
  CIV: 'ci',
  CGO: 'cd',
  COD: 'cd',
  COL: 'co',
  CPV: 'cv',
  CRO: 'hr',
  CUR: 'cw',
  CUW: 'cw',
  CZE: 'cz',
  DEN: 'dk',
  ECU: 'ec',
  EGY: 'eg',
  ENG: 'gb-eng',
  ESP: 'es',
  FRA: 'fr',
  GER: 'de',
  GHA: 'gh',
  HAI: 'ht',
  IRN: 'ir',
  IRQ: 'iq',
  ISL: 'is',
  ITA: 'it',
  JOR: 'jo',
  JPN: 'jp',
  KOR: 'kr',
  KSA: 'sa',
  MAR: 'ma',
  MEX: 'mx',
  NED: 'nl',
  NGA: 'ng',
  NOR: 'no',
  NZL: 'nz',
  PAN: 'pa',
  PAR: 'py',
  POL: 'pl',
  POR: 'pt',
  QAT: 'qa',
  ROU: 'ro',
  RSA: 'za',
  SCO: 'gb-sct',
  SEN: 'sn',
  SRB: 'rs',
  SUI: 'ch',
  SWE: 'se',
  TUN: 'tn',
  TUR: 'tr',
  UKR: 'ua',
  URU: 'uy',
  URY: 'uy',
  USA: 'us',
  UZB: 'uz',
  WAL: 'gb-wls'
};

/**
 * @param {string|null|undefined} tla FIFA 3-letter code e.g. BRA, ENG
 * @returns {string|null} flag-icons slug e.g. `br`, `gb-eng`
 */
export function fifaTlaToFlagCode(tla) {
  if (!tla || typeof tla !== 'string') return null;
  const key = tla.trim().toUpperCase();
  if (FIFA_TLA_TO_FLAG[key]) return FIFA_TLA_TO_FLAG[key];
  if (key.length === 2) return key.toLowerCase();
  return null;
}

/** Static SVG under /flags/4x3/ (vendored flag-icons subset). */
export function teamFlagUrlFromTla(tla) {
  const code = fifaTlaToFlagCode(tla);
  if (!code) return null;
  return `/flags/4x3/${code}.svg`;
}
